import { render } from "./CustomersFeedback.vue?vue&type=template&id=475f16fc"
import script from "./CustomersFeedback.vue?vue&type=script&lang=js"
export * from "./CustomersFeedback.vue?vue&type=script&lang=js"

import "./CustomersFeedback.vue?vue&type=style&index=0&id=475f16fc&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__